
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface BusinessAvatarProps {
  logoUrl?: string;
  name: string;
  size?: 'sm' | 'md';
  className?: string;
}

export const BusinessAvatar: React.FC<BusinessAvatarProps> = ({ 
  logoUrl, 
  name,
  size = 'md',
  className = ''
}) => {
  const getBusinessInitials = (businessName: string): string => {
    if (!businessName) return 'B';
    
    const words = businessName.trim().split(/\s+/);
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
  };

  const sizeClasses = size === 'sm' ? "h-8 w-8" : "h-8 w-8";

  return (
    <Avatar className={`${sizeClasses} rounded-md ${className}`}>
      <AvatarImage src={logoUrl} alt={name} className="rounded-md" />
      <AvatarFallback className="bg-gray-100 text-gray-600 rounded-md">
        {getBusinessInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
};
